/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Heading, Divider } from '@towersystems/towersystems-design-system';
import page from 'page';
import { map, size, get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/dashboard/connections/navigation';
import ResourcesList from './resources-list';
import { requestConnection } from 'state/connections/actions';
import { getAllConnectionTypes } from 'state/connection-types/selectors';

const Resources = ({ connectionId, connectionTypes, ...props }) => {
    const [requesting, setRequesting] = useState(true);
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        loadData(connectionId);
    }, []);

    const loadData = async (connectionId) => {
        setRequesting(true);
        try {
            let connection = await props.requestConnection(connectionId);



            setConnection(connection);
        } catch (error) {
            console.log('error', error);
            page('/');
        }

        setRequesting(false);
    };    

    const connectionType = get(connection, ["connection_type", "code"]);

    return (
        <Main>
            <Navigation connectionId={connectionId} section='resources' />
            <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                    <Heading level='1'>Resources</Heading>
                </Box>
                <Divider />
            </Box>
            <Stack space='medium'>
                <ResourcesList connectionId={connectionId || "123"} connectionType={connectionType} />
            </Stack>
        </Main>
    );
};

export default connect((state) => ({
    connectionTypes: getAllConnectionTypes(state),
}), {
    requestConnection,
})(Resources);
